<template><div><h1 id="veranstaltungen-fakturierung" tabindex="-1"><a class="header-anchor" href="#veranstaltungen-fakturierung"><span>Veranstaltungen Fakturierung</span></a></h1>
<p>Veranstaltungen Fakturierung — Fakturierung der definitven Teilnahmen und Refakturierung noch Storno</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit diesem Job werden alle Teilnahmen von <RouteLink to="/referenz/refs/ft.refdata.veranstaltung.html" title="Veranstaltung">Veranstaltungen</RouteLink> fakturiert, die sich im Auswahlbereich befinden. Fakturiert werden alle <RouteLink to="/referenz/refs/ft.refdata.veranstaltungsposition.html" title="Teilnehmer">Veranstaltungspositionen</RouteLink> mit Status &quot;definitiv&quot;, unabhängig vom Datum der Veranstaltung.</p>
<p>Pfad: <code v-pre>Veranstaltungen → Verarbeitungsläufe → Fakturen aufbereiten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Job (Datum/Nr.)</dt>
<dd>Wird beim Erfassen automatisch vergeben</dd>
<dt>Faktura-Art</dt>
<dd>Wahlweise können definitive Teilnahmen (Option &quot;fakturieren&quot;) oder stornierte Teilnahmen mit Gebühr (Option &quot;Refakturieren nach Storno&quot;) fakturiert werden.</dd>
<dt>Veranstaltungsjahr</dt>
<dd>Anwendung für <a class="link" href="ft.refdata.veranstaltung.html" title="Veranstaltung">Veranstaltungen</a> aus dem betreffenden Jahr (Filterkriterium).</dd>
<dt>von/bis Veranstaltung</dt>
<dd>Einschränkung nach Veranstaltungs-ID</dd>
<dt>Anzahl Fakturen</dt>
<dd>Anzahl Teilnahmen, die mit diesem Job fakturiert worden sind.</dd>
<dt>Anzahl Durchgänge</dt>
<dd>Zeigt an, wie oft der Job mit der Option &quot;Refakturieren nach Storno&quot; gelaufen ist.</dd>
<dt>Druckdatum</dt>
<dd>Datum Rechnungsdruck.</dd>
<dt>Druckdatei</dt>
<dd>Pfad und Name der Druckdatei.</dd>
<dt>Drucker</dt>
<dd>Drucker, auf den die Rechnungen ausgegeben werden (gilt nicht für Printoutput).</dd>
<dt>Status</dt>
<dd>
<table>
<thead>
<tr>
<th>Status</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>x</td>
<td>Job erledigt; keine ausstehenden Veranstaltungen gefunden</td>
</tr>
<tr>
<td>1</td>
<td>Job-Parameter erfasst; noch nicht aufbereitet; löschbar.</td>
</tr>
<tr>
<td>3</td>
<td>Protokoll aufbereitet; noch nicht gedruckt</td>
</tr>
<tr>
<td>9</td>
<td>Protokoll aufbereitet; gedruckt</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Diese Funktionen können im Kontextmenü gestartet werden:</p>
<h3 id="fakturieren" tabindex="-1"><a class="header-anchor" href="#fakturieren"><span>fakturieren</span></a></h3>
<p>Startet den Job für die Fakturierung der Teilnahmen und die Refakturierung nach einem Storno mit Gebühr.</p>
<h3 id="rechnungen-drucken" tabindex="-1"><a class="header-anchor" href="#rechnungen-drucken"><span>Rechnungen drucken</span></a></h3>
<p>Diese Funktion erstellt, je nach output, die PDF- und Druckdateien.</p>
<h3 id="rechnungskopien-drucken" tabindex="-1"><a class="header-anchor" href="#rechnungskopien-drucken"><span>Rechnungskopien drucken</span></a></h3>
<p>Dokumente können hier noch einmal erstellt/gedruckt werden.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.veranstaltung.html" title="Veranstaltung">Veranstaltungen</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.veranstaltungsposition.html" title="Teilnehmer">Veranstaltungspositionen</RouteLink></p>
</div></template>


